const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

const isConfigured = () =>
  Boolean(measurementId) && measurementId !== 'G-XXXXXXXXXX';

export function initializeAnalytics() {
  if (!isConfigured() || typeof window === 'undefined') return;
  if (window.__ga4Initialized) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });

  window.__ga4Initialized = true;
}

export function trackPageView(location) {
  if (!isConfigured() || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: `${location.pathname}${location.search}${location.hash}`,
  });
}

export function trackEvent(name, parameters = {}) {
  if (!isConfigured() || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', name, parameters);
}
